import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const AppLoader = ({ children }) => (
// TODO implement loader fallback component
_jsx(React.Suspense, Object.assign({ fallback: _jsx("h1", { children: "Loading app..." }) }, { children: children })));
export default AppLoader;
